import {
  Box,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@razorpay/blade/components';
import React from 'react';

export const ConfirmExecutionModal = ({
  isOpen,
  onDismiss,
  description,
  onConfirm,
  isExecutionInProgress,
}: {
  isOpen: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
  description?: string;
  isExecutionInProgress?: boolean;
}) => {
  return (
    <Modal isOpen={isOpen} onDismiss={onDismiss}>
      <ModalHeader title="Confirm to Proceed" />
      <ModalBody>
        <Text color="surface.text.gray.subtle">
          {description
            ? description
            : 'Please confirm to proceed with the processing of the uploaded sheet.'}
        </Text>
      </ModalBody>
      <ModalFooter>
        <Box display="flex" gap="spacing.5" justifyContent="flex-end">
          <Button variant="tertiary" onClick={onDismiss} isDisabled={isExecutionInProgress}>
            Go Back
          </Button>
          <Button variant="primary" onClick={onConfirm} isLoading={isExecutionInProgress}>
            Confirm
          </Button>
        </Box>
      </ModalFooter>
    </Modal>
  );
};
